module.exports = __webpack_public_path__ + "media/emoji_icons/neutral-c283bc7c.svg";